// extracted by mini-css-extract-plugin
module.exports = {"container":"Question_container__2t310","stem":"Question_stem__kJafd","title":"Question_title__2FgX1"};